import { FC } from "react"

export const AboutIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.75 13.25L12.791 13.23C12.9192 13.1659 13.0631 13.14 13.2057 13.1552C13.3482 13.1703 13.4834 13.2261 13.5952 13.3157C13.7071 13.4054 13.7909 13.5252 13.8368 13.661C13.8826 13.7968 13.8886 13.9429 13.854 14.082L13.146 16.918C13.1111 17.0572 13.1169 17.2034 13.1627 17.3394C13.2084 17.4754 13.2922 17.5954 13.4041 17.6852C13.516 17.775 13.6513 17.8308 13.794 17.846C13.9367 17.8612 14.0807 17.8352 14.209 17.771L14.25 17.75M22.5 14C22.5 15.1819 22.2672 16.3522 21.8149 17.4442C21.3626 18.5361 20.6997 19.5282 19.864 20.364C19.0282 21.1997 18.0361 21.8626 16.9442 22.3149C15.8522 22.7672 14.6819 23 13.5 23C12.3181 23 11.1478 22.7672 10.0558 22.3149C8.96392 21.8626 7.97177 21.1997 7.13604 20.364C6.30031 19.5282 5.63738 18.5361 5.18508 17.4442C4.73279 16.3522 4.5 15.1819 4.5 14C4.5 11.6131 5.44821 9.32387 7.13604 7.63604C8.82387 5.94821 11.1131 5 13.5 5C15.8869 5 18.1761 5.94821 19.864 7.63604C21.5518 9.32387 22.5 11.6131 22.5 14ZM13.5 10.25H13.508V10.258H13.5V10.25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
